import { type ReactNode } from 'react';
import { ActionBoardStoreProvider, usePersistActionBoardStore } from '@/actionBoards/actionBoard.store';
import { AdministrationStoreProvider } from '@/administration/administration.store';
import { AgentBuilderRunStoreProvider } from '@/agentBuilder/run/agentBuilderRun.store';
import { AnnotationStoreProvider, usePersistAnnotationStore } from '@/annotation/annotation.store';
import { sqAdministrationStore, sqAnnotationStore, sqStateSynchronizer } from '@/core/core.stores';
import { AddOnToolStoreProvider } from '@/homescreen/addOnTool.store';
import { ImpactReportStoreProvider, usePersistImpactReportStore } from '@/impactReports/impactReports.store';
import { PersistenceProvider } from '@/stores/PersistenceProvider';
import { SystemWarningStoreProvider } from '@/systemWarning/systemWarning.store';
import { VantageWorkbookStoreProvider } from '@/vantage/vantageWorkbook.store';

export const PersistStores = () => {
  // NOTE: this is where each store that needs to be persisted should be added using its custom hook.
  usePersistImpactReportStore();
  usePersistActionBoardStore();
  usePersistAnnotationStore();

  return null;
};

export const StoreProviders = ({ children }: { children: ReactNode }) => {
  return (
    <PersistenceProvider stateSynchronizer={sqStateSynchronizer}>
      <AdministrationStoreProvider store={sqAdministrationStore}>
        <ImpactReportStoreProvider>
          <VantageWorkbookStoreProvider>
            <ActionBoardStoreProvider>
              <SystemWarningStoreProvider>
                <AnnotationStoreProvider store={sqAnnotationStore}>
                  <AddOnToolStoreProvider>
                    <AgentBuilderRunStoreProvider>
                      <PersistStores />
                      {children}
                    </AgentBuilderRunStoreProvider>
                  </AddOnToolStoreProvider>
                </AnnotationStoreProvider>
              </SystemWarningStoreProvider>
            </ActionBoardStoreProvider>
          </VantageWorkbookStoreProvider>
        </ImpactReportStoreProvider>
      </AdministrationStoreProvider>
    </PersistenceProvider>
  );
};
